const hasPrintSubmenu = (webToPrintRoutes, routeData) => webToPrintRoutes && webToPrintRoutes.newsletter && routeData && routeData.webtoprint

export default hasPrintSubmenu

